import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const BulletList = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <circle cx='4.694' cy='5.066' r='1' fill='currentColor' />
        <path
          d='M9.094 5.216h10.8'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <circle cx='4.694' cy='12.266' r='1' fill='currentColor' />
        <path
          d='M9.094 12.416h10.8'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <circle cx='4.694' cy='19.466' r='1' fill='currentColor' />
        <path
          d='M9.094 19.616h10.8'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </>
    ) : (
      <>
        <circle cx='4.694' cy='5.066' r='1' fill='currentColor' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.194 5.216a.9.9 0 0 1 .9-.9h10.8a.9.9 0 1 1 0 1.8h-10.8a.9.9 0 0 1-.9-.9'
          fill='currentColor'
        />
        <circle cx='4.694' cy='12.266' r='1' fill='currentColor' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.194 12.416a.9.9 0 0 1 .9-.9h10.8a.9.9 0 0 1 0 1.8h-10.8a.9.9 0 0 1-.9-.9'
          fill='currentColor'
        />
        <circle cx='4.694' cy='19.466' r='1' fill='currentColor' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.194 19.616a.9.9 0 0 1 .9-.9h10.8a.9.9 0 1 1 0 1.8h-10.8a.9.9 0 0 1-.9-.9'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
